module.exports = __webpack_public_path__ + "media/images/fr/upload-online-695517ea6f1fc08868222c466b53439f.png";